import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import pluralize from 'pluralize'
import { CurrencyText, DimmerLoader, SummaryWidget, SummaryWidgetGroup } from '../../../../views/components'
import { apiStateSelectors } from '../../../api/apiState'
import { reportingApiEvents, reportingApiSelectors } from '../../../api/reporting'
import { toCents } from 'utils/currency'
import { uiEvents } from 'modules/ui'

const DashboardSummaryWidgets = () => {
  const dispatch = useDispatch()

  // Every dashboard tile is now served by the single consolidated
  // /reports/dashboard-summary-stats response (fetched once in DashboardPage),
  // replacing the former fan-out to Phoenix /accounting/stats (~7s),
  // /portfolios/stats and /reconciliations/stats. Money fields are in rand →
  // toCents() for the cents-based CurrencyText.
  const stats: any = useSelector(reportingApiSelectors.getDepositSummaryStats)
  const portfolio = stats?.Portfolio || {}

  const settledPercentageLast60Days = stats?.SettledPercentageLast60Days || 0
  const availableFunds = stats?.AvailableFunds || 0
  const fundsCollectedLast30Days = stats?.FundsCollectedLast30Days || 0
  const fundsCollectedPct = stats?.FundsCollectedPctChange30Days || 0
  const commissionLast30Days = stats?.CommissionLast30Days || 0
  const commissionPct = stats?.CommissionPctChange30Days || 0

  const managedOccupied = portfolio.ManagedOccupied || 0
  const unmanagedOccupied = portfolio.UnmanagedOccupied || 0
  const managedDraftCount = portfolio.ManagedDrafts || 0
  const unmanagedDraftCount = portfolio.UnmanagedDrafts || 0
  const startingNext30 = portfolio.StartingNext30Days || 0
  const endingNext30 = portfolio.EndingNext30Days || 0
  const renewalCount = portfolio.Renewals || 0

  // 30-day % deltas (now served by dashboard-summary-stats; Phoenix never
  // implemented these so they used to be a constant 0).
  const managedOccupiedPct = portfolio.ManagedOccupiedPctChange30Days || 0
  const unmanagedOccupiedPct = portfolio.UnmanagedOccupiedPctChange30Days || 0
  const startingNext30Pct = portfolio.StartingNext30DaysPctChange30Days || 0
  const endingNext30Pct = portfolio.EndingNext30DaysPctChange30Days || 0

  const isLoading = useSelector(state =>
    apiStateSelectors.isLoading(state)([reportingApiEvents.depositSummaryStats_request]),
  )

  return (
    <DimmerLoader loading={isLoading}>
      <SummaryWidgetGroup>
        <div>
          <h3>Properties</h3>
          <SummaryWidget
            title="Managed &amp; Occupied"
            amount={managedOccupied}
            percentageDiff={managedOccupiedPct}
            actions={[
              {
                label: `${managedDraftCount} ${pluralize('Draft', managedDraftCount)}`,
                onClick: () => {
                  dispatch(uiEvents.redirect('/leases?filter=draft&leaseType=managed'))
                },
              },
            ]}
          />
          <SummaryWidget
            title="Unmanaged &amp; Occupied"
            amount={unmanagedOccupied}
            percentageDiff={unmanagedOccupiedPct}
            actions={[
              {
                label: `${unmanagedDraftCount} ${pluralize('Draft', unmanagedDraftCount)}`,
                onClick: () => {
                  dispatch(uiEvents.redirect('/leases?filter=draft&leaseType=unmanaged'))
                },
              },
            ]}
          />
        </div>
        <div>
          <h3>Leases</h3>
          <SummaryWidget
            title="New Starting Next 30 Days"
            amount={startingNext30}
            percentageDiff={startingNext30Pct}
            actions={[
              {
                label: `${renewalCount || 0} ${pluralize('Renewals', renewalCount)} Scheduled`,
                onClick: () => {
                  dispatch(uiEvents.redirect('/leases?filter=renewals'))
                },
              },
            ]}
          />
          <SummaryWidget
            title="Ending Next 30 Days"
            amount={endingNext30}
            percentageDiff={endingNext30Pct}
            actions={[
              {
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
                label: <div dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />,
              },
            ]}
          />
        </div>
        <div>
          <h3>Collections</h3>
          <SummaryWidget
            title="Funds Collected Last 30 Days"
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string |... Remove this comment to see the full error message
            amount={<CurrencyText>{toCents(fundsCollectedLast30Days).getAmount()}</CurrencyText>}
            percentageDiff={fundsCollectedPct}
            actions={[
              {
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
                label: <div dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />,
              },
            ]}
          />
          <SummaryWidget
            title="Invoice Settled % Last 60 Days"
            amount={`${settledPercentageLast60Days || 0}%`}
            actions={[
              {
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
                label: (
                  <>
                    <CurrencyText>{toCents(availableFunds).getAmount()}</CurrencyText> Available Funds
                  </>
                ),
              },
            ]}
          />
        </div>
        <div>
          <h3>Commission</h3>
          <SummaryWidget
            title="Commission Last 30 Days"
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string |... Remove this comment to see the full error message
            amount={<CurrencyText>{toCents(commissionLast30Days).getAmount()}</CurrencyText>}
            percentageDiff={commissionPct}
            actions={[
              {
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
                label: <div dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />,
              },
            ]}
          />
        </div>
      </SummaryWidgetGroup>
    </DimmerLoader>
  )
}

export default DashboardSummaryWidgets
